import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexGDAOffersBenefitCard.scss';

const AmexGDAOffersBenefitCard = ({
  title, displayText, iconName, newText, baseRequestUrl,
}) => {
  const sanitizedTitle = sanitizeString(title);
  const sanitizedDisplayText = sanitizeString(displayText);

  const renderIcon = <img src={`${baseRequestUrl}GDA/Offers/icons/${iconName}`} alt={iconName} />;

  const benefitCard = (
    <div
      className="AmexGDAOffersBenefitCard"
      tabIndex="0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
    >
      <div className="AmexGDAOffersBenefitCard__border">
        <div className="AmexGDAOffersBenefitCard__border__benefitsBadgeBorder">
          {newText ? <span className="AmexGDAOffersBenefitCard__benefitsBadge">{newText}</span> : ''}
        </div>
        <div className="AmexGDAOffersBenefitCard__imageDisplay">
          <div className="AmexGDAOffersBenefitCard__image">
            {renderIcon}
          </div>
        </div>
        <div className="AmexGDAOffersBenefitCard__body">
          <h5
            className="AmexGDAOffersBenefitCard__title"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
          <div
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedDisplayText,
            }}
          />
        </div>
      </div>
    </div>
  );

  return benefitCard;
};

AmexGDAOffersBenefitCard.defaultProps = {
  newText: '',
  iconName: '',
};

AmexGDAOffersBenefitCard.propTypes = {
  title: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  newText: PropTypes.string,
  baseRequestUrl: PropTypes.string.isRequired,
};

export default AmexGDAOffersBenefitCard;
